import { Route, Routes } from "react-router-dom";
import { CaptchaTroughpass } from "./Components/User/Captcha Troughpass/CaptchaTroughpass";
import React from "react";
import { NotFound } from "./Components/Not Found/NotFound";
import { Header } from "./Components/Header/header";
import { BeneficiarySorry } from "./Components/Beneficiary/BeneficiarySorry";
import { Footer } from "./Components/Footer/footer";

// export function TokenRoutes(){
//     return (
//       <Routes>
//           <Route path="/confirmuser" element={
//               <CaptchaTroughpass api_endpoint={"token/newuser/confirm"} success_link={"/account/activated"} />
//             }>
//         </Route>
//         <Route path="/activateBeneficiary" element={
//             <CaptchaTroughpass api_endpoint={"token/activateBeneficiary"} success_link={"/beneficiary/login"} />
//           }>
//         </Route>
//         <Route path="/verifyEmail" element={
//             <CaptchaTroughpass api_endpoint={"token/verifyEmail"} success_link={"/logout"} />
//           }>
//         </Route>
//         <Route path="/selfrecovery" element={
//             <CaptchaTroughpass api_endpoint={"token/selfrecovery"} success_link={"/login/selfrecovery"} />
//           }>
//         </Route>
//         <Route path="/user/resetlogin" element={
//             <CaptchaTroughpass api_endpoint={"token/user/resetlogin"} success_link={"/login"} />
//           }>
//         </Route>

//       </Routes>
//     )

// }
const isFrench = localStorage.getItem("language") === "fr";
export const TokenRoutes = [
  <Route
    path="/confirmuser"
    element={
      <CaptchaTroughpass
        api_endpoint={"token/newuser/confirm"}
        success_link={"/account/activated"}
      />
    }
  ></Route>,
  <Route
    path="/activateBeneficiary"
    element={
      <CaptchaTroughpass
        api_endpoint={"token/activateBeneficiary"}
        success_link={"/beneficiary/login"}
        alternativeCode={404}
        alternativeModal={
          <>
            <Header
              elements={[
                {
                  text: isFrench
                    ? `OstreonPage d'accueil`
                    : "Ostreon Home Page",
                  link: "/",
                },
              ]}
            />
            <BeneficiarySorry />
            <Footer />
          </>
        }
      />
    }
  ></Route>,
  <Route
    path="/verifyEmail"
    element={
      <CaptchaTroughpass
        api_endpoint={"token/verifyEmail"}
        success_link={"/logout"}
      />
    }
  ></Route>,
  <Route
    path="/selfrecovery"
    element={
      <CaptchaTroughpass
        api_endpoint={"token/selfrecovery"}
        success_link={"/login/selfrecovery"}
      />
    }
  ></Route>,
  <Route
    path="/user/resetlogin"
    element={
      <CaptchaTroughpass
        api_endpoint={"token/user/resetlogin"}
        success_link={"/login"}
      />
    }
  ></Route>,
  <Route
    path="/partner/activate"
    element={
      <CaptchaTroughpass
        api_endpoint={"token/partner/activate"}
        success_link={"/partner/start"}
      />
    }
  ></Route>,
];
